<template>
<v-container fluid>
    <v-dialog persistent v-model="createOrderDialog" width="550" >
        <v-form v-model="createOrderValid" ref="createForm">
            <v-card class="pa-2">
                <v-card-title>
                    {{ $t('BuyOrderPage.create-order') }}
                </v-card-title>
                <v-card-text>
                    <v-row >
                        <v-col cols="12" >
                            <bee-date-picker
                                v-model="order_template.date"
                                context="bond"
                                :action-name="actions.CREATE"
                                :hide-details="true"
                                :label="$t('BuyOrderPage.order-date')"
                                :rules="[
                                    v => new Date(v) <= new Date() || false
                                ]"
                            ></bee-date-picker>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete 
                                v-model="order_template.accountId"
                                :items="configs.accounts.filter(c => c.type === type.sub)"
                                item-text="name"
                                item-value="id"
                                dense
                                outlined
                                hide-details
                                :label="$t('BuyOrderPage.external-account')"
                                :rules="[v => !!v]"
                            />
                        </v-col>
                        <v-col  cols="6" >
                            <v-text-field 
                            v-model="order_template.notes"
                            :label="$t('inputs.notes')"
                            outlined
                            dense
                            hide-details
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn text :disabled="!createOrderValid" color="greenDarken1" @click="$refs.createForm.validate(); submitOrder()">{{$t('buttons.create')}}</v-btn>
                    <v-btn
                    	text
                    	color="redDarken1"
                    	@click="resetCreateOrderForm()"
                    >{{$t('buttons.cancel')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

    </v-dialog>
    <v-dialog persistent transition="dialog-top-transition" v-model="createInvoiceDialog" max-width="800">
        <v-stepper v-model="stepper">
            <v-stepper-header class="px-5">
                <v-stepper-step
                    :complete="stepper > 1"
                    step="1"
                >
                    {{ $t('BuyOrderPage.fill-invoice-data') }}
                </v-stepper-step>
            
                <v-divider></v-divider>
            
                <v-stepper-step
                    :complete="stepper > 2"
                    step="2"
                >
                {{ $t('BuyOrderPage.choose-invoice-entries') }}
                </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content class="" step="1">
                    <v-form v-model="valid" ref="form">
                        <v-card class="">
                            <v-card-text class="pb-2 px-5">
                            <v-row class="ma-0 px-5 mx-2">
                                <v-col cols="auto" lg="12" class="pa-0">
                                    <bee-date-picker
                                        context="invoice"
                                        :action-name="actions.CREATE"
                                        :label="$t('InvoiceSalePage.invoice-date')"
                                        v-model="invoice_template.date"
                                        :rules="[
                                            v => new Date(v) <= new Date() || false
                                        ]"
                                    ></bee-date-picker>
                                </v-col>
                                <v-col cols="auto" lg="6" class="pt-0" v-if="useInvoiceCategories">
                                    <v-autocomplete
                                        v-model="invoice_template.category_id"
                                        :label="$t('InvoiceSalePage.invoice-category')"
                                        :items="invoiceCategories"
                                        item-text="name"
                                        item-value="id"
                                        outlined 
                                        dense
                                        hide-details
                                        clearable
                                        @change="suggestCategoryData"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="auto" lg="6" class="pt-0" v-if="useConfigInvoicesAccount">
                                    <v-autocomplete
                                        v-model="invoice_template.account_trade_config_id"
                                        :label="$t('inputs.purchasing-account')"
                                        :items="tradeConfigAccounts"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        dense
                                        hide-details
                                        clearable
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="auto" lg="9" class="py-0 d-flex flex-column">
                                    <bee-account-autocomplete
                                        context="invoice"
                                        :action-name="actions.CREATE"
                                        :hide-details="!isWarehousePermission ? true : false"
                                        :rules="[v => !!v]"
                                        :label="$t('InvoiceSalePage.account')"
                                        color="primary"
                                        v-model="invoice_template.external_account_id"
                                        :items="configs.accounts.filter(c=>c.type == 2)"
                                        :with-balance="!isWarehousePermission"
                                    ></bee-account-autocomplete>
                                </v-col>
                                <v-col class="py-0 ps-0">
                                    <bee-text-field
                                        context="invoice"
                                        :action-name="actions.EDIT"
                                        :label="$t('InvoiceSalePage.document')"
                                        :hide-details="!isWarehousePermission ? true : false"
                                        :rules="!canCreateInvoiceWithoutDocNo ?[v => !!v] : [true]"
                                        v-model="invoice_template.doc_no"
                                    ></bee-text-field>
                                </v-col>
                                <v-col cols="12" lg="6" v-if="!isWarehousePermission && useChangeCurrency">
                                    <v-autocomplete
                                        v-model="invoice_template.alternative_currency_id"
                                        :items="configs.currencies"
                                        :label="currencyNameCreate"
                                        item-value="id"
                                        item-text="symbol"
                                        dense
                                        hide-details
                                        outlined
                                        class="rounded-lg"
                                        @change="recommendCurrencyPriceCreate(invoice_template.alternative_currency_id)"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" lg="6" v-if="!isWarehousePermission && useChangeCurrency">
                                    <v-text-field
                                        v-model="invoice_template.currency_price"
                                        dense
                                        hide-details
                                        outlined
                                        :disabled="disableDefaultCurrencyPriceCreate"
                                        :label="$t('change-currency.currency-value')"
                                        class="rounded-lg"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="auto" lg="12" class="py-0">
                                    <bee-text-field
                                        context="invoice"
                                        :action-name="actions.EDIT"
                                        :label="$t('InvoiceSalePage.notes')"
                                        v-model="invoice_template.notes"
                                        :hide-details="true"
                                    ></bee-text-field>
                                </v-col>
                                <v-col class="pb-0 pt-3" v-if="useInvoiceCashType && !isWarehousePermission">
                                    <div class="d-flex align-center my-2">
                                        <p class=" mb-1">{{$t('InvoiceSalePage.payment-type')}}:</p>
                                        <v-radio-group  hide-details class="my-0 mx-2 py-0 pa-0" dense row v-model="invoice_template.payment_type">
                                            <v-radio  class="mx-3" :value="paymentType.debt" :label="$t('InvoiceSalePage.debt')" />
                                            <v-radio  class="mx-0" :value="paymentType.cash" :label="$t('InvoiceSalePage.cash')" />
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>
                            </v-card-text>
                            <v-card-actions class="ms-3">
                                <v-btn
                                    color="greenDarken1"
                                    text
                                    @click="stepper = 2"
                                >{{$t('buttons.next')}} </v-btn>
                                <v-btn color="redDarken1" text @click="reset()">{{$t('InvoiceSalePage.cancel')}}</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-stepper-content>
            
                <v-stepper-content step="2">
                    <v-card>
                        <v-card-text class="px-1">
                            <bee-handy-smart-table
                                v-if="editTableEntries.length"
                                ref="editTable"
                                v-model="editTableInputs"
                                height="300"
                                @item-selected="({ item, value}) => item.isSelected = value"
                                @toggle-select-all="({ value }) => {
                                    editTableEntries.forEach((item) => {
                                        item.isSelected = value;
                                    });
                                }"
                                class="mb-3"
                                fixed-header
                                :items-per-page="-1"
                                hide-default-footer
                                :headers="editHeaders"
                                :items="editTableEntries"
                                editable-rows
                                :data-table-props="{showSelect:true}"
                                @keydown.enter="saveEditedEntry()"
                            >
                            <template v-slot:input.warehouseId="{ on, attr}">
                                <v-autocomplete
                                	v-on="on"
                                	v-bind="attr"
                                    :items="
                                        userTypePermission === userType.warehouseKeeper && multipleWarehouses
                                            ? warehousesForKeeper
                                            : warehouses
                                    "
                                    :item-value="
                                        userTypePermission === userType.warehouseKeeper && multipleWarehouses
                                            ? 'warehouse_id'
                                            : 'id'
                                    "
                                    :item-text="
                                        userTypePermission === userType.warehouseKeeper && multipleWarehouses
                                            ? 'warehouse_name'
                                            : 'name'
                                            "
                                ></v-autocomplete>
                            </template>
                            <template v-slot:item.data-table-select="{ item, attrs, on, isSelected, select }">
                                <div class="d-flex justify-center align-center">
                                    <v-checkbox
                                    v-on="on"
                                    v-bind="attrs"
                                    :input-value="isSelected"
                                    @click="select2 = !isSelected;select(select2);"
                                    :ripple="false"
                                    hide-details
                                    dense
                                    class="ma-0 mb-1"
                                    />
                                </div>
                            </template>
                            <template v-slot:no-input.actions>
                                <div class="d-flex justify-center">
                                    <tooltip :text="$t('buttons.add')" top>
                                        <v-btn
                                            icon
                                            small
                                            color="greenDarken1"
                                            @click="saveEditedEntry()"
                                        >
                                            <v-icon>
                                                mdi-check-circle-outline
                                            </v-icon>
                                        </v-btn>
                                    </tooltip>
                                </div>
                            </template>
                            <template v-slot:item.actions="{ index }">
                                <div class="d-flex justify-center">
                                    <v-btn
                                        icon
                                        small
                                        color="warning-color"
                                        @click="() => {
                                            $refs.editTable.activeEditForRow(index); 
                                        }"
                                    >
                                        <v-icon>
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn> 
                                </div>
                            </template>
                            </bee-handy-smart-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                color="greenDarken1"
                                text
                                @click="createInvoice();"
                                >
                                {{ $t('BuyOrderPage.generate-invoice') }}
                            </v-btn>
                    
                            <v-btn color="primary" text @click="stepper = 1">
                            {{ $t('buttons.back') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                </v-stepper-content>
                <v-stepper-content step="3">
                    <div class="px-5 d-flex align-center pt-1 pb-5 text-h6">
                        <p class="ma-0">{{$t('BuyOrderPage.invoice-generated')}}</p>
                        <i class="fas fa-check mx-2 greenDarken1--text"></i>
                    </div>
                    <v-btn
                    color="greenDarken1"
                    text
                    @click="$router.push({name: 'invoices-buy', params: {id: invoiceId}})"
                    >
                    {{ $t('BuyOrderPage.show-invoice') }}
                    </v-btn>
            
                    <v-btn color="redDarken1" text @click="createInvoiceDialog = false; reset()">
                    {{ $t('close') }}
                    </v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="deleteDialog" width="450px">
        <v-card>
            <v-card-title>
                {{$t('BuyOrderPage.order-delete')}}
            </v-card-title>
            
            <v-card-text class="py-2">
                {{$t('BuyOrderPage.order-delete-alert')}}
            </v-card-text>

            <v-card-actions>
                <v-btn text color="success-color" @click="deleteOrder($route.params?.id)">{{$t('buttons.ok')}}</v-btn>
                <v-btn text color="danger-dark-color" @click="deleteDialog = false">
                    {{$t('buttons.cancel')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-row  dense class="mb-0 pb-0">
        <v-col cols="12" lg="auto">
            <slot name="breadcrumbs" :item="true"></slot>
        </v-col>
        <v-col cols="auto" class="d-flex">
            <bee-bond-up-down
                v-model="order_no"
                label="رقم الطلبية"
                class="medium-placeholder"
                :items="orders?.map(c => c.no)"
                @keydown-enter-prevent="updateRouteId()"
                @programmatically-changed="updateRouteId()"
            ></bee-bond-up-down>
        </v-col>
        <v-col cols="auto">
            <v-btn
                color="success white--text"
                :disabled="isViewer || loading"
                class="mx-2"
                @click="createOrderDialog = true"
            >
                <v-icon> mdi-plus </v-icon>
                {{$t('buttons.new')}}
            </v-btn>
        </v-col>
        <v-col cols="auto"  v-if="$route.params.id">
            <v-btn
                :disabled="isViewer || loading"
                color="danger-color"
                dark
                @click="deleteDialog = true"
            >
                <v-icon>
                    mdi-delete
                </v-icon>
                {{$t('buttons.delete')}}
            </v-btn
            >
        </v-col>
    </v-row>
    <v-row dense class=" mx-0 px-2 py-1 mb-2 my-border rounded-lg" >
        <v-col cols="auto" class="d-flex align-center">
            <bee-date-picker
            v-model="date"
            ref="dateEdit"
            context="invoice"
            :action-name="actions.EDIT"
            :label="$t('BuyOrderPage.order-date')"
            :disabled="order_status === orderStatus.done"
            :rules="[
                v => new Date(v) <= new Date() || false
            ]"
            :hide-details="true"
            @blur="submitOrder(true)"
        ></bee-date-picker>
        </v-col>
        <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
            <v-autocomplete 
                v-model="accountId"
                :items="configs.accounts.filter(c => c.type === type.sub)"
                :disabled="order_status === orderStatus.done"
                item-text="name"
                item-value="id"
                dense
                outlined
                hide-details
                :label="$t('BuyOrderPage.external-account')"
                @change="submitOrder(true)"
            />
        </v-col>
        <!-- warehouse -->
        <v-col lg="2" md="3" sm="4" cols="6">
            <v-autocomplete
                v-model="warehouseId"
                :items="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? warehousesForKeeper
                        : warehouses
                "
                :item-value="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_id'
                        : 'id'
                "
                :item-text="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_name'
                        : 'name'
                        "
                :label="$t('inputs.warehouse')"
                :disabled="order_status === orderStatus.done"
                dense
                outlined
                hide-details
                @change="materialId='';tableInputs.warehouseId = warehouseId"
            ></v-autocomplete>
        </v-col>
        
        <!-- material -->
        <v-col  lg="2" md="3" sm="4" cols="6">
            <v-autocomplete
                v-model="materialId"
                :label="$t('inputs.material')"
                :disabled="order_status === orderStatus.done"
                :item-text="c => `${c.no} - ${c.name}`"
                :items="materialsFilter(warehouseId, type.main)"
                item-value="id"
                dense
                outlined
                hide-details
                clearable 
                @change="filteredMaterials = [];getNodeMaterials()"
            >
                <template v-slot:item="data">
                    <v-list-item
                        class="py-1"
                        :class="type.main === data.item.type ? 'orangeLighten5': 'none'"
                        v-on="data.on"
                        v-bind="data.attrs"
                    >
                        <div>
                        {{ data.item.no + '-'+ data.item.name }}
                        </div>

                    </v-list-item>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col>
            <v-row dense>
                <v-col  cols="6">
                    <v-text-field 
                    v-model="notes"
                    :label="$t('inputs.notes')"
                    :disabled="order_status === orderStatus.done"
                    outlined
                    dense
                    hide-details
                    @change="submitOrder(true)"
                    />
                </v-col>
                <v-col cols="6">
                    <v-autocomplete
                        v-model="order_status"
                        :label="$t('BuyOrderPage.order-status')"
                        :items="orderStatuses"
                        item-text="name"
                        item-value="id"
                        dense 
                        outlined
                        hide-details
                        @change="changeOrderStatus()"
                    />
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
            <v-btn
            	color="blueGray"
            	class=" white--text"
                :disabled="loading || !$route.params.id || order_status === orderStatus.done"
            	@click="openCreateInvoiceDialog()"
            >
                {{ $t('BuyOrderPage.generate-buy-invoice') }}
            </v-btn>
        </v-col>
    </v-row>
    <bee-handy-smart-table 
        ref="table"
        v-model="tableInputs"
        :headers="headers"
        :items="entries || []"
        :loading="loading"
        fixed-header
        dense
        zebra
        :height="$vuetify.breakpoint.height - 220"
        :context-menu-items="contextMenuItems"
        :scroll-to-row-expression="(item) => item.id === entries[entries.length - 1]?.id"
        :items-per-page="10"
        pagination-on-scroll
        shown-rows-text=""
        hide-inputs-details
        :show-add-row="$route.params.id && order_status !== orderStatus.done"
        :disable-context-menu="!$route.params.id || order_status === orderStatus.done"
        :editable-rows="order_status !== orderStatus.done"
        :disable-input-fields="loading"
        @context-menu-edit="({ index, item }) => setRowIndexBeforeEdit(index,item)"
        @context-menu-delete="({ item }) => { rowId = item.id; deleteEntry()}"
        @keypress.enter="saveEntry"
    >
        <template v-slot:input.warehouseId="{ attr, on }">
            <v-autocomplete
                v-on="on"
                v-bind="attr"
                @change="tableInputs.materialId = null"
                :items="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? warehousesForKeeper
                        : warehouses
                "
                :item-value="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_id'
                        : 'id'
                "
                :item-text="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_name'
                        : 'name'
                "
            />
        </template>
        <template v-slot:input.materialId="{ attr, on }">
            <!-- <bee-material-autocomplete
                class="mb-1"
                v-on="on"
                v-bind="attr"
                :inside-table="true"
                :with-balance="true"
                :items="warehouseId !== tableInputs.warehouseId 
                            ? materials.filter(v => v.warehouse_id === tableInputs.warehouseId && v.type === type.sub)
                            :filteredMaterials.length 
                                ? filteredMaterials.filter(v => v.type === type.sub) 
                                : materials.filter(v => v.type === type.sub)"
            /> -->
            <v-autocomplete
                v-on="on"
                v-bind="attr"
                class="mb-3"
                :items="warehouseId !== tableInputs.warehouseId 
                            ? materialsFilter(tableInputs.warehouseId, type.sub)
                            :filteredMaterials.length
                                ? filteredMaterials.filter(v => v.type === type.sub) 
                                : materialsFilter(null,type.sub)"
                :item-text="c => `${c.no} - ${c.name}`"
                item-value="id"
                hide-details
            >
                <template v-slot:item="data">
                    <v-list-item
                        :class="type.main === data.item.type ? 'orangeLighten5': 'none'"
                        v-on="data.on"
                        v-bind="data.attrs"
                    >
                        <div class="d-flex flex-column py-1">
                            <span>
                                {{ data.item.no + '-'+ data.item.name }}
                            </span>
                        </div>
                        <v-spacer></v-spacer>
                        <bee-material-amount-label :with-color="true" :value="data.item.balance" :show-zeros-values="true"></bee-material-amount-label>

                    </v-list-item>
                </template>
            </v-autocomplete>
        </template>
        <template v-slot:item.hint="{ item, index }">
            <div class="text-center" v-if="$route.params.id && order_status !== orderStatus.done">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attr }">
                        <v-btn
                            small
                            icon
                            v-bind="attr"
                            v-on="on"
                            width="32"
                        >
                            <v-icon>
                                mdi-dots-vertical
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="setRowIndexBeforeEdit(index,item)">
                            <v-list-item-content class="pa-0">
                                {{ $t('buttons.edit') }}
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="rowId = item.id; deleteEntry()">
                            <v-list-item-content class="pa-0">
                                {{ $t('buttons.delete') }}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </template>
    </bee-handy-smart-table>
</v-container>
</template>
<script>
import rules from '../../../validation'
import actions from "../../../permissions/actions-names.js"
import EventBus from '@/event-bus'
import { mapState, mapGetters } from 'vuex'
import { userType, paymentType, type, invoiceType, userPermission, orderType, orderStatuses, orderStatus } from '../../../helpers/enums'
import { useChangeCurrency, useInvoiceCashType, useConfigInvoicesAccount, canCreateInvoiceWithoutDocNo, useInvoiceCategories, multipleWarehouses } from '@/configs/global'
export default {
    data : () => ({
        accountId: null,
        warehouseId: null,
        materialId: null,
        notes: null,
        date: null,
        invoice_template:{
            external_account_id: null,
            date: new Date().toISOString().substr(0, 10).toString(),
            doc_no: null,
            notes: null,
            account_trade_config_id: null,
            category_id: null,
            payment_type: 1,
            alternative_currency_id: null,
            currency_price: null
        },
        order_template: {
            accountId: null,
            notes: null,
            order_no: null,
            date: new Date().toISOString().substr(0, 10).toString()
        },
        createInvoiceDialog: false,
        rules,
        actions,
        loading: false,
        useChangeCurrency, 
        useInvoiceCashType,
        multipleWarehouses,
        useConfigInvoicesAccount, 
        canCreateInvoiceWithoutDocNo,
        useInvoiceCategories,
        paymentType,
        userType,
        orderType,
        type,
        orderStatuses,
        orderStatus,
        alternativeCurrencyId: null,
        default_currency_id: null,
        tableInputs: {},
        valid: true,
        alternativeCurrencyPrice: null,
		stepper: 1,
		test2: null,
        select2: false,
        selectedRows: [],
        createOrderDialog: false,
        createOrderValid: true,
        filteredMaterials: [],
        order: {},
        order_no: null,
        order_entries: [],
        rowId: null,
        EventBus,
        entries: [],
        editTableEntries: [],
        editTableInputs: {},
        invoiceId: null,
        deleteDialog: false,
        order_status: null
    }),
    watch: {
        '$route'(val, oldVal) {
            if(val.params.id) {
                this.fetchOrder(val.params.id);
            } else if (oldVal.params.id && this.orders.find(v => v.id === oldVal.params.id)) {
                this.$router.push({name: 'buy-order', params: {id: oldVal.params.id}});
            }
        }
    },
    computed: {
        ...mapState({
            userTypePermission: state => state.permissions.user_type,
            currentFinancialFile: state => state.financialFiles.current_financial_file,
            configs: state => state.configs.configs,
            defaultFinancialFileAccounts: state => state.configs.default_financial_file_accounts,
            warehousesForKeeper: state => state.permissions.warehousesForKeeper,
            warehouses: state => state.warehouses.warehouses,
            materials: state => state.materials.materials,
            orders : state => state.orders.orders,
            invoiceCategories: state =>
            state.invoiceCategories.invoiceCategories
                .filter(c => c.category_invoice_types.map(c => c.invoice_type).includes(invoiceType.buy))
        }),
        ...mapGetters({
            isViewer: 'permissions/isViewer',
            getAccountById: 'configs/getAccountById',
            getOrderByNo: 'orders/getOrderByNo',
            getMaterialById: 'materials/getMaterialById',
            getWarehouseById: 'warehouses/getById',
            getInvoiceCategoryById: 'invoiceCategories/getInvoiceCategoryById'
        }),
        headers () {
            return [
                {
                    text: this.$t('headers.no'),
                    name: 'no',
                    value: 'no',
                    sortable: false,
					width: '80',
                    disableInput: true
                },
                {
                    text: this.$t('inputs.warehouse'),
                    name: 'warehouseId',
                    value: 'warehouse_id',
                    sortable: false,
                    width: '25%',
                    setValueExpr: (val) => this.getWarehouseById(val)?.name
                    // setValueExpr: value =>
                    //     this.warehouses.find(c =>
                    //         c.id === this.materials.find(e => e.id === this.buyStatement?.find(k => k.material_id === value)?.material_id
                    //         )?.warehouse_id)?.name
                },
                {
                    text: this.$t('headers.material'),
                    name: 'materialId',
                    value: 'material_id',
                    sortable: false,
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                {
                    text: this.$t('headers.quantity'),
                    name: 'quantity',
                    value: 'quantity.quantity',
                    sortable: false,
					width: '10%'
                },
                {
                    text: this.$t('headers.count'),
                    name: 'count',
                    value: 'count',
                    sortable: false,
					width: '10%'
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'notes',
                    value: 'notes',
                    sortable: false,
					width:'20%'
                },
                {
                    text: '',
                    name: 'hint',
                    noInput: true,
                    value: '',
                    width:50
                }

            ]
        },
		editHeaders () {
            return [
                {
                    text: this.$t('headers.no'),
                    name: 'no',
                    value: 'no',
                    sortable: false,
					width: '60',
                    disableInput: true,
                },
                {
                    text: this.$t('inputs.warehouse'),
                    name: 'warehouseId',
                    value: 'warehouse_id',
                    sortable: false,
                    disableInput: true,
                    setValueExpr: val => this.getWarehouseById(val)?.name
                    // setValueExpr: value =>
                    //     this.warehouses.find(c =>
                    //         c.id === this.materials.find(e => e.id === this.buyStatement?.find(k => k.material_id === value)?.material_id
                    //         )?.warehouse_id)?.name
                },
                {
                    text: this.$t('headers.material'),
                    name: 'material',
                    value: 'material_id',
                    sortable: false,
                    disableInput: true,
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                {
                    text: this.$t('headers.quantity'),
                    name: 'quantity',
                    value: 'quantity.quantity',
                    sortable: false,
					width: '8%',
                    type: 'number'
                },
                {
                    text: this.$t('headers.count'),
                    name: 'count',
                    value: 'count',
                    sortable: false,
                    type: 'number',
					width: '8%'
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'notes',
                    value: 'notes',
                    sortable: false,
					width:'15%'
                },
                {
                    text: '',
                    name: 'actions',
                    noInput:true,
                    value: '',
                    width:70
                }
            ]
		},
        isWarehousePermission() {
            return (this.userTypePermission === userType.warehouseKeeper) || (this.userTypePermission === userType.warehouseManger)
        },
        isAccountantPermission() {
            return (this.userTypePermission === userPermission.accountant 
                        || this.userTypePermission === userPermission.advanceAccountant)
        },
        currencyNameCreate() {
            if (this.invoice_template.alternative_currency_id) {
                return this.$t('change-currency.currency') + ': ' + this.configs.currencies.find(c => c.id === this.invoice_template.alternative_currency_id)?.name
            }
            return this.$t('change-currency.currency')
        },
        contextMenuItems() {
            const items = [            {
                    event: 'edit',
                    title: this.$t('InvoiceSalePage.context-menu.edit'),
                }]
                items.push({
                    event: 'delete',
                    title: this.$t('InvoiceSalePage.context-menu.delete'),
                })
            return items;
        },
        currencyNameUpdate() {
            if (this.alternativeCurrencyId) {
                return this.$t('change-currency.currency') + ': ' + this.configs.currencies.find(c => c.id === this.alternativeCurrencyId)?.name
            }
            return this.$t('change-currency.currency')
        },

        disableDefaultCurrencyPrice() {
            return Boolean(this.alternativeCurrencyId === this.currentFinancialFile.default_currency_id)
        },

        disableDefaultCurrencyPriceCreate() {
            return Boolean(this.invoice_template.alternative_currency_id === this.currentFinancialFile.default_currency_id)
        },
        tradeConfigAccounts() {
            return [
                { 
                    ...(
                        this.getAccountById(this.defaultFinancialFileAccounts.buy_account_id) || {}
                    ),
                    id: null
                },
                ...this.configs.accounts,
            ].filter(c =>
                c.type === type.sub &&
                c.id !== this.defaultFinancialFileAccounts.buy_account_id
            )
        },
        file_is_locked(){ return this.configs?.financial_file?.is_locked },
        materialsFilter() {
            return (warehouseId, type) => warehouseId 
            ?this.materials.filter(v => v.warehouse_id === warehouseId && v.type===type) 
            :this.materials.filter(v => v.type===type)
        }
    },
    methods: {
        submitOrder(isUpdate = false) {
            const orderPayload = {
                orderType : orderType.buy,
                external_account_id: isUpdate
                    ? this.accountId 
                    :this.order_template.accountId,
                doc_no : '',
                date: isUpdate 
                    ? this.date
                    : this.order_template.date,
                id: this.$route.params.id,
                notes: isUpdate
                    ? this.notes 
                    : this.order_template.notes
            }
            const actionName = isUpdate ? 'update' : 'create';
            this.$store.dispatch(`orders/${actionName}Order`, orderPayload).then(() => {
                this.fetchOrders().then(() => {
                    this.createOrderDialog = false;
                    this.$refs.table.resetInputs();
                    this.tableInputs.warehouseId = this.warehouses.find(c => c.is_default === true)?.id;
                    if(isUpdate) {
                        EventBus.$emit("notification", this.$t('BuyOrderPage.order-updated'));
                    } else {
                        this.$router.replace({name: 'buy-order', params: {id:this.orders[this.orders.length - 1]?.id}});
                    }
                });

            })
        },
        fetchOrders() {
            return this.$store.dispatch('orders/fetchOrders', orderType.buy);
        },
        fetchOrder(id) {
            this.loading = true;
            return this.$store.dispatch('orders/fetchOrder', {orderType: orderType.buy , id}).then(data => {
                this.order = data;
                this.date = data.date;
                this.accountId = data.external_account_id;
                this.notes = data.notes
                this.order_no = data.no;
                this.order_status = data.order_status
                console.log(this.order_status)
                this.entries = data.order_entries.map(v => ({
                    id: v.id,
                    no: v.no,
                    warehouse_id: this.getMaterialById(v.material_id)?.warehouse_id,
                    material_id: v.material_id,
                    quantity: v.quantity,
                    count: v.count,
                    notes: v.notes
                }))
                this.warehouseId = this.warehouses.find(c => c.is_default === true)?.id;
                this.tableInputs.warehouseId = this.warehouseId;
                this.loading = false;
                return data;
            })
        },
        saveEntry() {
            const actionName = this.rowId ? 'update': 'create'; 
            const entry = {
                material_id : this.tableInputs.materialId,
                quantity: {
                    quantity: +this.tableInputs.quantity,
                    unit_size_id: null
                },
                count: +this.tableInputs.count,
                notes: this.tableInputs.notes
            }
            this.$store.dispatch(`orders/${actionName}Entry`, 
            {
                orderType:orderType.buy , 
                entry:entry , 
                entryId: this.rowId,
                id:this.$route.params.id
            }).then(() => {

                this.$refs.table.resetInputs();
                this.$refs.table.resetEdit();
                this.fetchOrder(this.$route.params.id).then(data => {
                    // console.log(data);
                    if(actionName === 'create') {
                        this.$nextTick(() => {
                            data.order_entries.length? this.$refs.table.scrollToRow():null;
                        })
                    }
                });
                this.rowId = null;
            })
        },
        deleteEntry() {
            this.loading=true;
            this.$store.dispatch('orders/deleteEntry', {
                id: this.$route.params.id,
                entryId: this.rowId,
                orderType: orderType.buy
            }).then(() => {
                this.loading = false
                this.rowId = null;
                this.fetchOrder(this.$route.params.id);
            }).finally(() => this.loading = false)
        },
        deleteOrder(id) {
            this.$store.dispatch('orders/deleteOrder', {orderType: orderType.buy, id}).then(() => {
                this.fetchOrders().then(() => {
                    const length = this.orders?.length;
                    if(length) {
                        this.$router.replace({name:'buy-order', params: {id: this.orders[length - 1].id}})
                    } else {
                        /*reset the page*/
                        this.deleteDialog = false;
                        this.order_no = null;
                        this.date = null;
                        this.notes = null;
                        this.materialId = null;
                        this.accountId = null;
                        this.warehouseId = null;
                        this.$router.replace({name:'buy-order'})
                    }
                })
            })
        },
        changeOrderStatus() {
            this.$store.dispatch('orders/changeOrderStatus', {
                id: this.$route.params.id,
                orderType: orderType.buy,
                status: this.order_status
            }).then(() => {
                this.fetchOrder(this.$route.params.id).then(() => {
                    EventBus.$emit("notification", this.$t('BuyOrderPage.order-updated'));
                });
            })
        },
        saveEditedEntry() {
            const index = this.editTableEntries.findIndex(v => v.no===this.editTableInputs.no);
            this.editTableEntries[index].count = this.editTableInputs.count;
            this.editTableEntries[index].quantity.quantity = this.editTableInputs.quantity;
            this.editTableEntries[index].notes = this.editTableInputs.notes;
            this.$refs.editTable.resetEdit();
        },
        createInvoice() {
            const data = this.invoice_template;
            const selectedEntries = this.editTableEntries.filter( v => v.isSelected);
            const invoice = {
                external_account_id: data.external_account_id,
                date: data.date,
                doc_no: data.doc_no,
                notes: data.notes,
                account_trade_config_id: data.account_trade_config_id,
                category_id: data.category_id,
                payment_type: data.payment_type,
                alternative_currency_id: this.currentFinancialFile.default_currency_id !== data.alternative_currency_id
                    ? data.alternative_currency_id
                    : null,
                currency_price: this.currentFinancialFile.default_currency_id !== data.alternative_currency_id
                    ? data.currency_price 
                    :null,
                invoice_entries: selectedEntries.map(v => ({
                    material_id : v.material_id,
                    quantity: v.quantity,
                    count: v.count,
                    notes: v.notes,
                    price: {
                        amount: 0,
                        currency_id: this.currentFinancialFile.default_currency_id
                    },
                    calculated_total_amount: {
                        amount: 0 ,
                        currency_id: this.currentFinancialFile.default_currency_id
                    },
                    discount_amount: null,
                    discount_percentage: 0,
                    sub_invoice_type_id: null,
                    alternative_price: this.currentFinancialFile.default_currency_id !== data.alternative_currency_id
                    ? {
                        amount: 0,
                        currency_id: data.alternative_currency_id
                    } 
                    : null,
                    alternative_calculated_total_amount: this.currentFinancialFile.default_currency_id !== data.alternative_currency_id
                    ? {
                        amount: 0,
                        currency_id: data.alternative_currency_id
                    } 
                    :null,
                    alternative_discount_amount: null
                }))
            }
            this.$store.dispatch('orders/createInvoice', {invoiceType: invoiceType.buy, order_id : this.$route.params.id, invoice}).then((data) => {
                this.stepper=3;
                this.invoiceId = data;
            })
        },
        updateRouteId() {
            let newId = this.getOrderByNo(this.order_no)?.id
            // console.log(this.order_no)
            if(newId) {
                this.$router.push({name: 'buy-order', params: {id: newId}})
            }
        },
        suggestCategoryData() {
            if (!useInvoiceCategories) return;
            let matchedCategory = this.getInvoiceCategoryById(this.invoice_template.category_id);
            if(matchedCategory) {
                this.invoice_template.account_trade_config_id = matchedCategory?.purchases_account_id;
                this.invoice_template.external_account_id = matchedCategory?.customer_account_id;
            }
        },
        recommendCurrencyPriceCreate(value) {
            if (value === this.currentFinancialFile.default_currency_id) {
                this.invoice_template.currency_price = 1
            } else {
                this.invoice_template.currency_price = this.configs.currencies.find(e => e.id === value).latest_exchange_record
            }
        },

        recommendCurrencyDefaultPriceUpdate(value) {
            if (value === this.currentFinancialFile.default_currency_id) {
                this.invoice_template.alternative_currency_id = 1
            } else {
                this.invoice_template.alternative_currency_id  = this.configs.currencies.find(e => e.id === value).latest_exchange_record
            }
        },
        reset(){
            this.loading = false
            this.invoice_template.external_account_id = null
            this.invoice_template.doc_no = null
            this.invoice_template.notes = null
            this.invoice_template.date = new Date().toISOString().substr(0, 10).toString()
            this.createInvoiceDialog = false
            this.$refs.form.resetValidation()
            this.invoice_template.alternative_currency_id = this.currentFinancialFile.default_currency_id
            this.invoice_template.currency_price = 1;
            this.editTableEntries = [];
        },
        getNodeMaterials() {
            const data = {
                nodeId : this.materialId,
                warehouseId : this.warehouseId
            }
            this.$store.dispatch('materials/getNodeMaterials', data).then(data => {
                this.filteredMaterials = data 
            })
        },
        setRowIndexBeforeEdit(index, item) {
            this.rowId = item.id;
            this.$refs.table.activeEditForRow(index);
        },
        resetCreateOrderForm() {
            this.order_template.accountId = null; this.order_template.notes = null;this.createOrderDialog = false
        },
        openCreateInvoiceDialog() {
            this.recommendCurrencyDefaultPriceUpdate(this.currentFinancialFile.default_currency_id);
            this.recommendCurrencyPriceCreate(this.currentFinancialFile.default_currency_id)
            this.stepper=1;
            this.createInvoiceDialog = true;
            this.invoice_template.external_account_id =this.accountId;
            this.editTableEntries = JSON.parse(JSON.stringify(this.entries.map(c => ({ ...c, isSelected: false }))));
        }
    },
    mounted() {
        this.loading = true
        const promises = [
        !this.warehouses.length
            ? this.$store.dispatch('warehouses/fetchAll')
            : null,
        !this.materials.length 
            ? this.$store.dispatch('materials/fetchAll') 
            : null,
        !this.orders.length 
            ?this.fetchOrders()
            :null
        ]
        if (Object.keys(this.configs).length == 0) {
            promises.push(this.$store.dispatch('configs/fetchAll'))
        }
        if (!this.invoiceCategories.length && useInvoiceCategories) {
            promises.push(this.$store.dispatch('invoiceCategories/fetchAll'));
            promises.push(this.$store.dispatch('invoiceCategories/fetchDefaultCategories'));
        }
        Promise.all(promises).then(() => {
            if(this.$route.params.id) {
                this.fetchOrder(this.$route.params.id)
            }else if(this.orders.length) {
                this.$router.replace({name: 'buy-order', params: {id: this.orders[this.orders.length - 1].id}})
            } else {
                this.loading = false;
                this.entries = [];
                this.notes = null;
                this.accountId = null;
                this.materialId = null;
                this.order_status =null;
                this.warehouseId = null;
            }
        }) 

    }
}
</script>
<style>
</style>